import React, { useState } from 'react';

function CollapsibleSection({ title, children, defaultOpen = false, className = '' }) {
    const [isOpen, setIsOpen] = useState(defaultOpen);

    const renderTitle = () => {
        if (typeof title === 'string') {
            return <h3>{title}</h3>;
        }
        return <div className="custom-title">{title}</div>;
    };

    return (
        <div className={`collapsible-section ${className}`}>
            <div
                className={`section-header ${isOpen ? 'open' : 'closed'}`}
                onClick={() => setIsOpen(!isOpen)}
            >
                {renderTitle()}
                <span className="collapse-indicator">
                    {isOpen ? '▼' : '▶'}
                </span>
            </div>
            {isOpen && (
                <div className="section-content">
                    {children}
                </div>
            )}
        </div>
    );
}

export default CollapsibleSection;